import { ApolloError} from "@apollo/client";
import { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import { Button, Alert, Col, Form, FormFeedback, FormGroup, Input, Label, Row } from "reactstrap";
import { IOrgLight } from "../../../types/org";
import { ISearchPositionInput } from "../../../types/position";
import { validEmail } from "../../../utils/commons";
import { SearchIcon } from "../../common/icons";
import TopOrganizationTypeahead from "../../common/typeahead/top-organization-typeahead";

type SearchPositionRoleFormProp={
    loading: boolean
    error: ApolloError | undefined
    onSearch: (input:ISearchPositionInput,isValid: boolean)=>void
    onChange: ()=>void
}

export type SearchPositionFormRef = {
  getInput:() => ISearchPositionInput;
};

const SearchPositionRoleForm= forwardRef<SearchPositionFormRef, SearchPositionRoleFormProp>((props,ref) => {
  const { loading, error, onSearch,onChange } = props;
  const [input,setInput] = useState<ISearchPositionInput>({orgId:0,title:'',email:'',phoneFax:''});
  const [valid,setValid] = useState(true);
  const [warning, setWarning] = useState('');
  const [errors, setErrors] = useState({org:'', email:'',phoneFax:''});

  useEffect(()=>{
    setValid( !errors.org && !errors.email&&!errors.phoneFax)
  },[errors])

  const getInput = () =>{
    return input;
  }
  useImperativeHandle(ref, () => ({
    getInput
  }));

  const orgSelectHandle = (org: IOrgLight | undefined) => {
    //setInput({...input,orgId:org?.id||0})
    const orgId = org?.id || 0;
    setInput((prevInput) => ({ ...prevInput, orgId }));
    setErrors((prevErrors) => ({ ...prevErrors, org: '' }));
    onChange();
  }

  const onTitleChange = (event:any) => {
    setInput({...input,title:event.target.value.trim()})
    onChange();
  }

  const onPhoneFaxChange = (event:any) => {
    setInput({...input,phoneFax:event.target.value.trim().replaceAll("-","")})
    onChange();
  }

  const onEmailChange = (event:any) => {
    setInput({...input,email:event.target.value.trim()})
    setErrors({...errors,email:''})
    onChange();
  }

  const handleReset = () => {
    clear();
  };

  const clear = () => {
    setWarning('');
    onChange();
  };

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    clear();

    if (input.email&&!validEmail(input.email)) {
        errors.email = "Wrong email";
    }
    setErrors({...errors});

    if(!errors.org && !errors.email && !errors.phoneFax){
      onSearch(input,!!input.email || !!input.phoneFax || !!input.title);
    }
  }

  return (
    <Form onSubmit={handleSubmit} onReset={handleReset}>
      <Row>
        <Col md={6}>
          <FormGroup row>
            <Label for="orgId" sm={4}>
              Under Top Level:
            </Label>
            <Col sm={8}>
              <TopOrganizationTypeahead elementId="top-org" orgSelectHandle={orgSelectHandle} validate={(error)=>errors.org=error}/>
            </Col>
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col md={6}>
          <FormGroup row>
            <Label for="title" sm={4}>Position/Role Title:</Label>
            <Col sm={8}>
              <Input id="title" name="title" placeholder="Enter a full or partial position/role title..." onChange={(event)=>onTitleChange(event)}/>
            </Col>
          </FormGroup>
        </Col>
        <Col md={6}>
          <FormGroup row>
            <Label for="email" sm={4}>Position/Role Email:</Label>
            <Col sm={8}>
              <Input id="email" name="email" placeholder="Enter a position/role email address" invalid={!!errors.email} onChange={(event)=>onEmailChange(event)} />
              <FormFeedback>{errors.email}</FormFeedback>
            </Col>
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col md={6}>
          <FormGroup row>
            <Label for="phoneFax" sm={4}>Position/Role Phone/Fax:</Label>
            <Col sm={8}>
              <Input id="phoneFax" name="phoneFax" placeholder="Enter a ten-digit phone or fax number" onChange={(event)=>onPhoneFaxChange(event)}/>
            </Col>
          </FormGroup>
        </Col>
      </Row>

      <Row>
        <Col className="oms-row right-align-col">
          <Button type="submit" color="primary" disabled={!valid}>
            <SearchIcon /> Search
          </Button>
        </Col>
      </Row>
      {warning && <Alert color="warning">{warning}</Alert>}
      {error && <Alert color="danger">Error searching orgs.</Alert>}
    </Form>
  )
});

export default SearchPositionRoleForm
